import React from 'react';
import useStyle from './EspaceProfBlock.style';
import { classNames } from 'helpers/style/classNames';

interface EspaceProfBlockProps {
  variant: 'MaClasse' | 'Dashboard';
  content?: 'default' | 'controlTab';
  onClick: () => void;
}
export const EspaceProfBlock = ({
  onClick,
  variant,
  content = 'default'
}: EspaceProfBlockProps) => {
  const classes = useStyle();
  return (
    <div
      className={classNames([classes.root, classes[variant]])}
      onClick={onClick}
    >
      <p className={classes.title}>
        {content === 'default' ? 'Espace Prof' : 'Contrôle des commandes'}
      </p>

      <p className={classes.paragraph}>
        {content === 'default'
          ? 'Tous vos outils pour piloter la classe'
          : 'Contrôlez les commandes de vos élèves au fur et à mesure du challenge'}
      </p>
    </div>
  );
};
